import { Component } from '@angular/core';

@Component({
  selector: 'app-cancelar-remessa',
  templateUrl: './cancelar-remessa.component.html',
  styleUrl: './cancelar-remessa.component.css'
})
export class CancelarRemessaComponent {

}
